module.exports = __webpack_public_path__ + "static/media/loader.68b36929.svg";